import { render, staticRenderFns } from "./CauselistList.vue?vue&type=template&id=44cf84e8&scoped=true"
import script from "./CauselistList.vue?vue&type=script&lang=js"
export * from "./CauselistList.vue?vue&type=script&lang=js"
import style0 from "./CauselistList.vue?vue&type=style&index=0&id=44cf84e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cf84e8",
  null
  
)

export default component.exports